module.exports = __webpack_public_path__ + "dbd1e3de130c3d80f9e0096d1499e579.png";